export const adapterContent = (content: ContentAem): ContentApp => {
  if (!content) {
    throw new Error('no content provided to `adapterContent`');
  }
  const { fields } = content;
  const { theme, carouselTitle, headlineHierarchy, slides, assetFormat } = fields;
  const slidesModified = slides.map((slide) => {
    const {
      slideAssetType,
      slideCtaText,
      slideCtaUrl,
      slideCtaAriaLabel,
      slideCtaUrlTarget,
      slideDescription,
      slideDisclaimer,
      slideImageAlt,
      slideLandscapeAlt,
      slideImageAsset,
      slideImageLandscapeAsset,
      slideTitle,
      slideWltpKeys,
      slideVideoLandscapeAsset,
      slideVideoLandscapeCaption,
      slideVideoLandscapeAudio,
      slideVideoLandscapeAlt,
      slideVideoPortraitAsset,
      slideVideoPortraitCaption,
      slideVideoPortraitAudio,
      slideVideoPortraitAlt,
      slideVideoAutoPlay,
      slideVideoLoop,
      slideVideoPreserveVideoWidth,
    } = slide.fields;

    return {
      slideAssetType,
      slideCtaText,
      slideCtaUrl,
      slideCtaAriaLabel,
      slideCtaUrlTarget,
      slideDescription,
      slideDisclaimer,
      slideImageAlt,
      slideLandscapeAlt,
      slideImageAssetPath: slideImageAsset?.path || '',
      slideImageLandscapeAssetPath: slideImageLandscapeAsset?.path || '',
      slideTitle,
      slideWltpKeys: slideWltpKeys || [],
      ...(slideAssetType === 'video' && {
        slideVideoLandscapeAssetPath: slideVideoLandscapeAsset?.path,
        slideVideoLandscapeCaption: slideVideoLandscapeCaption?.path,
        slideVideoLandscapeAudioPath: slideVideoLandscapeAudio?.path,
        slideVideoLandscapeAlt,
        slideVideoPortraitAssetPath: slideVideoPortraitAsset?.path,
        slideVideoPortraitCaption: slideVideoPortraitCaption?.path,
        slideVideoPortraitAudioPath: slideVideoPortraitAudio?.path,
        slideVideoPortraitAlt,
        slideVideoAutoPlay,
        slideVideoLoop,
        slideVideoPreserveVideoWidth,
      }),
    };
  });

  return {
    theme,
    carouselTitle,
    headlineHierarchy: headlineHierarchy || 'h2',
    slides: slidesModified,
    assetFormat: assetFormat || 'small',
  };
};
